import Api from '@/api/api.js'

export default {
    /**
     * Liste des consommables
     */
    consommables() {
        const promise = Api().get('/consommables')
        return promise.then((response) => response.data)
    },

    getListeConsommables() {
        const promise = Api().get('/consommables/liste-all-consumable')
        return promise.then((response) => response.data)
    },
}